import { useContext } from "react";
import { AutoTableRowContext } from "./auto-table-row-provider.contants";

export const useAutoTableRowProvider = () => {
    const context = useContext(AutoTableRowContext);
    if (!context) {
        throw new Error("useAutoTableRowProvider must be used within an AutoTableRowProvider");
    }
    return context;
};
